module.exports = ".card{\n    margin-top:50px;\n    \n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/sistema/sistema.component.css
// module id = ./src/app/modulos/sistema/sistema.component.css
// module chunks = main